import React, { useEffect, useState } from 'react'
import { DatePicker } from 'antd';
import Select from 'react-select';
import { formatDate, isValidEmail, onlyAlphabets, onlyNumeric } from '../../../components/commonClass/CommonValidation';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { useNavigate } from 'react-router-dom';

const CorporateQueryCreate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((store: any) => store?.userstatus?.tba);
    const menuItem = useSelector((store: any) => store?.menuitems?.menu);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [dropdownList, setDropDownList] = useState<any>([])
    const [formValue, setFormValue] = useState({
        CorporateQueryId: 0,
        TravelCategoryId: 0,
        FirstName: '',
        LastName: '',
        EmailId: '',
        PhoneNo: '',
        LocationId: 0,
        Adult: 0,
        Child: 0,
        Infant: 0,
        TravelDate: null,
        PackageId: 0,
        Description: '',
        UserId: 0,
    })

    const [formErrors, setFormErrors] = useState<any>({})

    const getcorporatequeryoptions = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const list = await getAllData('/midoffice/v1/getcorporatequeryoptions')
            if (list?.status) {
                const rawCityList = list?.data?.cityList || [];
                const cityList = rawCityList?.map((obj: any) => ({
                    label: obj?.City,
                    value: obj?.LocationId,
                }));
                const rawPackageList = list?.data?.packageList || [];
                const packageList = rawPackageList?.map((obj: any) => ({
                    label: obj?.PackageName,
                    value: obj?.PackageId,
                    code: obj?.PackageCode,
                }));
                const rawtravelCategoryList = list?.data?.productList || [];
                const travelCategoryList = rawtravelCategoryList?.map((obj: any) => ({
                    label: obj?.TravelCategoryName,
                    value: obj?.TravelCategoryId
                }));
                const rawAssigneeList = list?.data?.assigneeList || [];
                const assigneeList = rawAssigneeList?.map((obj: any) => ({
                    label: obj?.FullName,
                    value: obj?.UserMasterID,
                    ImagePath: obj?.ImagePath,
                }));
                setDropDownList({ cityList, packageList, assigneeList, travelCategoryList });
            }
            else {
                setDropDownList([]);
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
        dispatch(loaderActions.end());
    }

    const decrementCount = (e: any, name: string) => {
        setFormErrors({})
        setFormValue((form: any) => ({ ...form, [name]: form?.[name] - 1 }))
    }

    const incrementCount = (e: any, name: string) => {
        setFormErrors({})
        setFormValue((form: any) => ({ ...form, [name]: form?.[name] + 1 }))
    }

    const val = [{
        label: <>
            <div className='d-flex flex-column'>
                <div className='col-lg-6 col-md-12'>
                    <p className='float-start pt-2'>
                        <i className="fa-solid fa-user me-1"></i>Adult
                    </p>
                    <p className='float-end'>
                        <ul className="d-flex align-items-center p-0 mb-0">
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => decrementCount(e, 'Adult')}
                                    disabled={formValue?.Adult <= 0}
                                    className="btn btn-primary count_btn_search m-0 p-0">
                                    <i className="fa-solid fa-minus" />
                                </button>
                            </li>
                            <li className="mx-2 fs-6"><small className='my-0'>{formValue?.Adult}</small></li>
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => incrementCount(e, 'Adult')}
                                    className="btn btn-primary count_btn_search m-0 p-0">
                                    <i className="fa-solid fa-plus" />
                                </button>
                            </li>
                        </ul>
                    </p>
                </div>
                <div className='col-lg-6 col-md-12'>
                    <p className='float-start pt-2'>
                        <i className="fa-solid fa-children me-1"></i>Child
                    </p>
                    <p className='float-end'>
                        <ul className="d-flex align-items-center p-0 mb-0">
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => decrementCount(e, 'Child')}
                                    disabled={formValue?.Child <= 0}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-minus" />
                                </button>
                            </li>
                            <li className="mx-2 fs-6"><small className='my-0'>{formValue?.Child}</small></li>
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => incrementCount(e, 'Child')}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-plus" />
                                </button>
                            </li>
                        </ul>
                    </p>
                </div>
                <div className='col-lg-6 col-md-12'>
                    <p className='float-start pt-2 pb-0 mb-0'>
                        <i className="fa-solid fa-baby me-1"></i>Infant
                    </p>
                    <p className='float-end pb-0 mb-0'>
                        <ul className="d-flex align-items-center p-0 mb-0">
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => decrementCount(e, 'Infant')}
                                    disabled={formValue?.Infant <= 0}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-minus" />
                                </button>
                            </li>
                            <li className="mx-2 fs-6"><small className='my-0'>{formValue?.Infant}</small></li>
                            <li>
                                <button
                                    type="button"
                                    onClick={(e: any) => incrementCount(e, 'Infant')}
                                    className="btn btn-primary count_btn_search m-0 p-0"
                                >
                                    <i className="fa-solid fa-plus" />
                                </button>
                            </li>
                        </ul>
                    </p>
                </div>
            </div>
        </>, value: 1
    }]


    const handleChange = (name: any, val: any) => {
        setFormErrors({})
        setFormValue((form: any) => ({ ...form, [name]: val }))
    }

    const validateData = () => {
        let status: boolean = true;
        const error: any = {}
        if (formValue?.TravelCategoryId === 0) {
            error.TravelCategoryId = "Please select product.";
            status = false;
        }
        if (formValue?.FirstName?.trim()?.length === 0) {
            error.FirstName = "Cannot leave blank, please provide first name.";
            status = false;
        }
        if (formValue?.LastName?.trim()?.length === 0) {
            error.LastName = "Cannot leave blank, please provide last name.";
            status = false;
        }
        if (formValue?.EmailId?.trim()?.length === 0) {
            error.EmailId = "Cannot leave blank, please provide email ID.";
            status = false;
        }
        else if (formValue?.EmailId?.trim()?.length > 0 && !isValidEmail(formValue?.EmailId)) {
            error.EmailId = " Please provide valid Email Id.";
            status = false;
        }
        if (formValue?.PhoneNo?.trim()?.length === 0) {
            error.PhoneNo = "Cannot leave blank, please provide phone number.";
            status = false;
        }
        else if (formValue?.PhoneNo?.trim()?.length < 10) {
            error.PhoneNo = "Please provide valid Phone No.";
            status = false;
        }


        if (Object.keys(error).length > 0) {
            let id = Object.keys(error)[0];
            let doc = document.getElementById(id);
            if (doc !== null)
                doc.focus();
        }

        setFormErrors(error);
        return status;
    }


    const clearData = () => {
        setFormValue({
            CorporateQueryId: 0,
            TravelCategoryId: 0,
            FirstName: '',
            LastName: '',
            PhoneNo: '',
            EmailId: '',
            LocationId: 0,
            Adult: 0,
            Child: 0,
            Infant: 0,
            TravelDate: null,
            PackageId: 0,
            Description: '',
            UserId: 0,
        })
    }

    const handlesavedata = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let user: any = GetLocalStorage();
                formValue.UserId = user?.userMasterID
                const RpsData = await postUsersData("/midoffice/v1/insertcorporatequery", formValue);
                if (RpsData?.status) {
                    dispatch({ type: 'ALERTINGMESSAGE', message: RpsData?.message, path: "/corporate-querylog" })
                    clearData();
                    setFormErrors({})
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: RpsData?.message })
                    dispatch(loaderActions.end());
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
    }


    useEffect(() => {
        //check for rights
        let pagelink = user?.find((x: any) => {
            if (x?.PageLink === window?.location?.pathname)
                return x.MenuId
        });
        let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter((x: any) => x.MenuId === pagelink?.MenuId)?.map((obj: any) => {
            setUserAdd(obj?.URightAdd);
            setUserEdit(obj?.URightEdit);
            setUserExport(obj?.URightExport);
        });
    }, [user])

    useEffect(() => {
        getcorporatequeryoptions();
    }, [])

    const inputdisable = (formValue?.TravelCategoryId === 0
        || formValue?.FirstName?.trim()?.length === 0
        || formValue?.LastName?.trim()?.length === 0
        || formValue?.EmailId?.trim()?.length === 0
        || formValue?.PhoneNo?.trim()?.length === 0
    )


    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{menuItem?.[0]?.pageTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <div className='row'>
                    <div className='col-6'>
                        <h4>{menuItem?.[2]?.pageTitle}</h4>
                    </div>
                    <div className='col-6 text-end'>
                        <button type="button" className="btn btn-primary" disabled={inputdisable || !useradd} onClick={handlesavedata} id="btnAdd">Create</button>
                    </div>
                </div>
            </div>
            <div className="mt-2">
                <div className=' mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='FirstName' className='form-label required'>Select Product</label>
                                </div>
                                <div className='col-8'>
                                    <Select
                                        id='TravelCategoryId'
                                        name='TravelCategoryId'
                                        className='dropdown select_dropdown custom_class'
                                        options={dropdownList?.travelCategoryList}
                                        value={dropdownList?.travelCategoryList?.filter((fil: any) => formValue?.TravelCategoryId === fil?.value)}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        placeholder='Select'
                                        onChange={(e: any) => handleChange('TravelCategoryId', e?.value)}
                                        isClearable
                                    />
                                    {formErrors?.TravelCategoryId && <div className='text-danger text-start fs_14'>{formErrors?.TravelCategoryId}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='create_query_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Customer Details</h5>
                </div>
                <div className=' mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='FirstName' className='form-label required'>First Name</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='FirstName'
                                        className='form-control'
                                        name='FirstName'
                                        type='text'
                                        placeholder='First Name'
                                        value={formValue?.FirstName}
                                        maxLength={100}
                                        onChange={(e: any) => handleChange('FirstName', onlyAlphabets(e?.target?.value))}
                                    />
                                    {formErrors?.FirstName && <div className='text-danger text-start fs_14'>{formErrors?.FirstName}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='LastName' className='form-label required'>Last Name</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='LastName'
                                        className='form-control'
                                        name='LastName'
                                        type='text'
                                        placeholder='Last Name'
                                        value={formValue?.LastName}
                                        maxLength={100}
                                        onChange={(e: any) => handleChange('LastName', onlyAlphabets(e?.target?.value))}
                                    />
                                    {formErrors?.LastName && <div className='text-danger text-start fs_14'>{formErrors?.LastName}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='EmailId' className='form-label required'>Email Id</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='EmailId'
                                        className='form-control'
                                        name='EmailId'
                                        type='text'
                                        placeholder='Email Id'
                                        value={formValue?.EmailId}
                                        maxLength={120}
                                        onChange={(e: any) => handleChange('EmailId', e?.target?.value)}
                                    />
                                    {formErrors?.EmailId && <div className='text-danger text-start fs_14'>{formErrors?.EmailId}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='PhoneNo' className='form-label required'>Phone No.</label>
                                </div>
                                <div className='col-8'>
                                    <input
                                        id='PhoneNo'
                                        className='form-control'
                                        name='PhoneNo'
                                        type='text'
                                        placeholder='Phone No'
                                        value={formValue?.PhoneNo}
                                        maxLength={12}
                                        onChange={(e: any) => handleChange('PhoneNo', onlyNumeric(e?.target?.value))}
                                    />
                                    {formErrors?.PhoneNo && <div className='text-danger text-start fs_14'>{formErrors?.PhoneNo}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='create_query_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Trip Details</h5>
                </div>
                <div className=' mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='LocationId' className='form-label'>Origin City</label>
                                </div>
                                <div className='col-8'>
                                    <Select
                                        id='LocationId'
                                        name='LocationId'
                                        className='dropdown select_dropdown custom_class'
                                        options={dropdownList?.cityList}
                                        value={dropdownList?.cityList?.filter((fil: any) => formValue?.LocationId === fil?.value)}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        placeholder='Select'
                                        onChange={(e: any) => handleChange('LocationId', e?.value)}
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-4 mb-1'>
                                    <label className="form-label">No. Of traveler</label>
                                </div>
                                <div className='col-8 mb-1'>
                                    <Select
                                        id='genderid'
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: 'white',
                                                primary50: 'white',
                                            },
                                        })}
                                        className="dropdown select_dropdown custom_class increment_select"
                                        options={val}
                                        value={val?.filter(function (val: any) {
                                            return val.value === 0;
                                        })}
                                        closeMenuOnSelect={false}
                                        placeholder={<>
                                            <span className='me-1'>Adult</span>
                                            <span className='me-1'>({formValue?.Adult}),</span>
                                            <span className='me-1'>Child</span>
                                            <span className='me-1'>({formValue?.Child}),</span>
                                            <span className='me-1'>Infant</span>
                                            <span className='me-1'>({formValue?.Infant})</span>
                                        </>}
                                        isSearchable={false}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-4 mb-1'>
                                    <label className="form-label">Travel Date</label>
                                </div>
                                <div className='col-8 mb-1'>
                                    <DatePicker
                                        name='TravelDate'
                                        className='form-control antd_date_picker'
                                        placeholder='Travel Date'
                                        minDate={dayjs(new Date())}
                                        format={'DD-MM-YYYY'}
                                        onChange={(e: any) => handleChange("TravelDate", e?.$d ? formatDate(e?.$d) + 'T00:00:00' : null)}
                                        value={formValue?.TravelDate !== null ? dayjs(new Date(formValue?.TravelDate)) : null}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center mb-1'>
                                <div className='col-4'>
                                    <label htmlFor='PackageId' className='form-label'>Package Name/ID</label>
                                </div>
                                <div className='col-8'>
                                    <Select
                                        id='PackageId'
                                        name='PackageId'
                                        className='dropdown select_dropdown custom_class'
                                        options={dropdownList?.packageList}
                                        value={dropdownList?.packageList?.filter((fil: any) => formValue?.PackageId === fil?.value)}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        placeholder='Select'
                                        onChange={(e: any) => handleChange('PackageId', e?.value)}
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='create_query_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Query Description</h5>
                </div>
                <div className=' mt-2 p-2'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-2 mb-1'>
                                    <label htmlFor='Description' className="form-label">Query In detail</label>
                                </div>
                                <div className='col-10 mb-1'>
                                    <textarea
                                        rows={3}
                                        id='Description'
                                        name='Description'
                                        className="form-control"
                                        placeholder="Query In detail"
                                        maxLength={1500}
                                        onChange={(e: any) => handleChange('Description', e?.target?.value)}
                                        value={formValue?.Description}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CorporateQueryCreate